import { render } from "./Add.vue?vue&type=template&id=10bb1e48&scoped=true&lang=pug"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=10bb1e48&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bb1e48"]])

export default __exports__